// extracted by mini-css-extract-plugin
export default {"container":"Header_container__HGAIb","logo":"Header_logo__sDSCj","titleContainer":"Header_titleContainer__6jqG8","toggleContainer":"Header_toggleContainer__14uB6"};